import styled from 'styled-components';
import { Box } from '@bechtel/gds';

export const PageHeaderStyled = styled(Box).attrs({
  alignItems: { sm: 'center' },
})`
  height: ${({ theme }) => theme.componentStyles.pageHeaderHeight};
  width: 100%;
  box-shadow: ${({ theme }) => theme.componentStyles.boxShadow};
  background-color: #fff;
  justify-content: space-between;
  position: relative;
`;
